let iframe = {
  status: false,
  open(link) {
    this.status = true;
    let overlay = document.createElement('div');
    overlay.id = 'iframe-overlay';
    overlay.title = 'Close';
    overlay.style.zIndex = '100';
    overlay.style.position = 'fixed';
    overlay.style.width = '100%';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.cursor = 'pointer';
    overlay.onclick = () => {
      this.close();
    }

    let iframe = document.createElement('iframe');
    iframe.src = link;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '2px solid white';
    iframe.style.backgroundColor = 'white';

    let closeButton = document.createElement('div');
    closeButton.innerHTML = '&#10006;';
    closeButton.style.paddingBottom = '0.1rem';
    closeButton.style.cursor = 'pointer';
    closeButton.style.fontWeight = 'bold';
    closeButton.style.fontSize = '1.5rem';
    closeButton.style.width = '4rem';
    closeButton.style.height = '4rem';
    closeButton.style.display = 'flex';
    closeButton.style.justifyContent = 'center';
    closeButton.style.alignItems = 'center';
    closeButton.style.backgroundColor = 'white';
    closeButton.style.borderBottomLeftRadius = '100%';
    closeButton.style.borderTopLeftRadius = '100%';
    closeButton.style.position = 'absolute';
    closeButton.style.right = '0rem';
    closeButton.style.top = 'calc(50% - 2rem)';

    overlay.appendChild(iframe);
    overlay.appendChild(closeButton);
    document.querySelector('#app').appendChild(overlay);
  },
  close() {
    this.status = false;
    document.querySelector('#iframe-overlay').remove();
  }
}

export default iframe;